export default {
    buttons: {
        search: 'Suchen',
        choose: 'Wählen',
        chosen: 'Gewählt',
        close: 'Schließen',
    },

    property_type: {
        unit: 'Einheit',
        building: 'Gebäude',
        parcel: 'Grundstück',
        flat: 'Wohnung',
        family_house: 'Familie Haus',
        recreational: 'Freizeiteinrichtung',
        apartment_house: 'Wohnhaus',
        hut: 'Hütte',
        cottage: 'Kate',
        land: 'Grundbesitz',
    },

    data: {
        all_data: 'Alle Daten',
        purchased_only: 'Nur gekauft',
    },

    parameters: {
        district: 'Bezird',
        village: 'Dorf',
        cadastre_area: 'Katastergebiete',
        period: 'Periode',
        unit_usage: 'Art der Verwendung des Geräts',
        building_usage: 'Art der Verwendung des Gebäudes',
        land_type: 'Art des Grundstücks',
        share_area: 'Fläche nach Anteil',
        parcel_under: 'Parzelle unter dem Gebäude',
        parcel_area: 'Grundstücksfläche',
        by_pairing: 'Nach der Paarung',
        paired: 'Gedämpft',
        to_pair: 'Für die Paarung',
        without_candidates: 'Keine Kandidaten',

        form: {
            names: {
                ownership: "Eigentum",
                disposition: "Anordnung",
                construction: "Konstruktion",
                floor: "Etage der Wohnung",
                total_floors: "Gesamte Stockwerke",
                rating: "Zustand der Immobilie",
                land_type: "Landtyp",
                building_type: "Art des Bauobjekts",
                subcategory: "Unterkategorie",
                construction_quality: "Qualität der Konstruktion",
            },

            rating: {
                bad: 'Unbewohnbar',
                nothing_much: 'Vor dem Wiederaufbau',
                good: 'Durchschnitt',
                very_good: 'Sehr gut',
                new: 'Neubau',
                excellent: 'Luxuriös',

                help: {
                    flat: {
                        bad: 'Eine Wohnung, in der ohne kompletten Umbau nicht mehr zu leben ist. Das Badezimmer und die Küche fehlen.',
                        nothing_much: 'Eine Wohnung, in der ohne kompletten Umbau nicht mehr zu leben ist. Bad und Küche fehlen. Hier kann man wohnen, aber Bad und Küche sind min. 25 Jahre alt und hätte eine Modernisierung verdient. Dies sind zum Beispiel Plattenwohnungen mit einem Umakarta-Kern.',
                        good: 'Küche und Bad sind in einem Zustand, dass sie ohne größere Umbauten voll genutzt werden können. Sie sind jedoch nicht nach vollständiger Rekonstruktion in den letzten Jahren.',
                        very_good: 'Die Wohnung wurde komplett renoviert (Küche, Bad, Fenster).',
                        new: 'Normaler Neubau oder fast neue Immobilie. Der Preis sollte ähnlich wie bei anderen Neubauten in der Gegend sein.',
                        excellent: 'Es werden sehr teure Technologien und Materialien verwendet. Der Preis dürfte deutlich über den üblichen Neubauten in der Gegend liegen.'
                    },

                    house: {
                        bad: 'Das Haus ist für den Abriss oder den kompletten Wiederaufbau (Dach, Fenster, Fassade, Küche, Bad) vorgesehen.',
                        nothing_much: 'Seit mindestens 25 Jahren hat hier kein Wiederaufbau stattgefunden. Der Innen- und Außenbereich verdient eine Modernisierung.',
                        good: 'Das Haus kann bequem genutzt werden. In den letzten Jahren wurde jedoch weder innen noch außen renoviert.',
                        very_good: 'Das Haus wurde komplett renoviert (Dach, Fenster, Fassade, Küche, Bad).',
                        new: 'Normaler Neubau oder fast neue Immobilie. Der Preis sollte ähnlich wie bei anderen Neubauten in der Gegend sein.',
                        excellent: 'Es werden sehr teure Technologien und Materialien verwendet. Der Preis dürfte deutlich über den üblichen Neubauten in der Gegend liegen.'
                    },
                },
            },

            land_type: {
                null: 'Nicht aufgeführt',
                building: 'Konstruktion',
                field: 'Feld',
                garden: 'Garten',
                meadow: 'Wiese',
                forest: 'Wald',
                other: 'Andere',
            },

            house_subtype: {
                unified_panel: 'Panel',
                unified_other: 'Typish',
                atypical: 'Nicht-typisch',
                individual: 'Individuell',
                semi_detached: 'Doppelhaushälfte',
                row_house: 'Reihenhaus',
                hut: 'Hütte',
                cottage: 'Landhaus',
                help: {
                    unified_panel: 'Ein klassischer Plattenbau des 20. Jahrhunderts, dessen Struktur aus vorgefertigten Stahlbetonteilen zusammengesetzt ist.',
                    unified_other: 'Wohngebäude, die in ihrer Bauweise repetitiv sind (einen bestimmten Typus, einen mehrfach wiederholten Grundriss haben oder nur geringfügig nach den Wünschen des Kunden verändert werden). Das Bausystem ist jedes, außer Fertigbauweise, z. B. ein großes Entwicklungsprojekt, bei dem 2 Typen von Mehrfamilienhäusern verwendet werden, die sich mehrmals auf dem Grundstück wiederholen.',
                    atypical: 'Wohngebäude, die eine einzigartige Form und einen einzigartigen Grundriss haben (werden nur einmal gebaut). Das Bausystem ist ein beliebiges, aber vorgefertigtes System.',
                    individual: 'Es handelt sich um ein freistehendes Einfamilienhaus.',
                    semi_detached: 'Ein freistehendes Haus, das eine gemeinsame Wand mit dem Haus nebenan teilt.',
                    row_house: 'Ein Einfamilienhaus, das in einer Reihe dicht nebeneinander angeordnet ist und eine tragende Wand mit dem Nachbarhaus teilt.',
                    hut: 'Ein Gebäude, das für die individuelle Erholung bestimmt ist. Es darf unterkellert sein und nicht mehr als ein Stockwerk und ein Dachgeschoss haben.',
                    cottage: 'Ein Gebäude, das nicht nur der Erholung dient, sondern auch zum ganzjährigen Wohnen genutzt werden kann.',
                }
            },

            floors: {
                basement: "Untergeschoss",
                first_floor: "Erdgeschoss",
                floor: "Über Erdgeschoss",
            },

            ownership: {
                null: 'Nicht aufgeführt',
                private: 'Persönlich',
                cooperative: 'Kooperative',
                council: 'Staatlich/kommunal',
                other: 'Andere',
            },

            local_type: {
                null: 'Nicht aufgeführt',
                '1+kk': '1+kk',
                '1+1': '1+1',
                '2+kk': '2+kk',
                '2+1': '2+1',
                '3+kk': '3+kk',
                '3+1': '3+1',
                '4+kk': '4+kk',
                '4+1': '4+1',
                'jiné': 'andere',
            },

            constructions: {
                null: 'Nicht aufgeführt',
                brick: 'Ziegel',
                wood: 'Hölzern',
                stone: 'Stein',
                montage: 'Gebaut',
                monolithic_bar: 'Monolithisch',
                monolithic_panel: 'Panel',
                not_specified: 'Nicht angegeben',
                panel: 'Tafel',
                prefabricated: 'Vorgefertigt',
                mixed: 'Gemischt',
                low_energy: 'Wenig Energie',
                other: 'Anderer',
            },

            construction_quality: {
                standard: 'Standard',
                low: 'Niedrig',
                high: 'Hoch',
                very_high: 'Sehr Hoch',
                help: {
                    standard: 'Es enthält Grundelemente, <strong>keine zusätzliche Ausstattung</strong>. Standardmaterialien, klassische Ausstattung (1x Bad und WC), klassische verputzte Fassade mit Isolierung. Das Dach besteht aus Ziegeln (Keramik, Beton) oder Metall.',
                    low: 'Die für den Bau verwendeten Materialien und Ausrüstungen sind <strong>von geringer Qualität</strong>. Das Gebäude enthält keine Elemente, die in der Standardmaterialausstattung beschrieben sind. Der niedrige Standard des Materials kann durch eine visuelle Inspektion erkannt werden. Er steht in Zusammenhang mit der Qualität der Materialien und der Qualität der Ausführung (mehr unvollständige Arbeiten, Reklamationen und Fehler). Er enthält auch Elemente, die die <strong>problemlose Nutzung des Gebäudes verhindern.',
                    high: '<strong>Enthält einige der folgenden Elemente</strong>: Balkon, Loggia, Terrasse, Speisekammer, Keller, Waschküche, Gemeinschaftsräume. Toilette oder Badezimmer gibt es mehr als einmal (z.B. 2x Toilette und inkl. Dusche und Bad). Das <strong>verwendete Material ist hochwertig </strong>(großformatige Fliesen, Design-Schalter/Steckdosen, großformatige Fenster, PVC-Folienbedachung).',
                    very_high: '<strong> Enthält einige der Elemente des vorherigen Standards plus einige der folgenden Elemente</strong>: Kamin, Sauna, Schwimmbad, Zentralstaubsauger, Fußbodenheizung, Klimaanlage, elektrische Jalousien und Rollläden, Fliesen und dekorative Elemente (Steinfliesen, Sichtbeton, Edelstahlelemente, Mosaike, Holzparkett). Dazu gehören auch die Außenanlagen des Gebäudes: Sonnenkollektoren, Regenwassertanks, hinterlüftete Fassaden (grün, Metall, Holz), Dach (grün, Kupfer, Schindel, Schiefer, schräg, Schiebedach).',
                },
            },
        },
    },

    titles: {
        property_type: 'Art der Immobilie',
        address: 'Adresse',
        sale_lease: 'Kauf oder Miete',
        more: 'Details der Immobilie',
        disposition: 'die Disposition',
        as_of: 'Berechnen Sie die Schätzung zum Datum',
    },

    kind: {
        sale: 'Kauf',
        lease: 'Miete',

        help: {
            sale: 'Ich möchte den aktuellen üblichen Preis dieser Immobilie wissen',
            lease: 'Ich möchte den aktuellen üblichen Mietpreis für diese Immobilie wissen',
        }
    },

    autocomplete: {
        placeholder: "Adresse oder Koordinaten in der Form 50.1000593, 13.4360036",
        no_result: "Keine Einträge gefunden",
        loading: "Wird geladen...",
    },

    disposition: {
        floor_area: "Geschossfläche",
        lot_area: "Grundstücksbereich",
        balcony: "Balkon + Loggia + Terrasse",
        garden: "Eigener Garten",
        cellar: "Keller",
        garage: "Garage",
        other_area: "Unbewohnbare Gegend",

        help: {
            floor_area_other: 'Die Bodenfläche wird in Valuo im Vergleich zur Regierungsverordnung Nr. 366/2013 Sb. als die Summe aller Räume OHNE alle vertikalen tragenden und nicht tragenden Strukturen innerhalb des Gebäudes verstanden, wie Wände, Säulen, Pfeiler, Schornsteine und ähnliche vertikale Strukturen.',
            floor_area_flat: 'Die Bodenfläche wird in Valuo im Vergleich zur Regierungsverordnung Nr. 366/2013 Sb. als die Summe aller Räume OHNE alle vertikalen tragenden und nicht tragenden Strukturen innerhalb der Wohnung verstanden, wie Wände, Säulen, Pfeiler, Schornsteine und ähnliche vertikale Strukturen.',
            flat_reproduction_price: 'Der Reproduktionspreis wird für das gesamte Gebäude berechnet, er kann also nicht für eine bestimmte Wohneinheit ermittelt werden. Wenn Sie den Preis der Wohnung für die Versicherung herausfinden müssen, verwenden Sie unsere Marktpreisberechnung.'
        }
    },

    custom_area: {
        title: 'Individuelle Flächen',
        modal_btn: 'Individuelle Flächen',
        remove: 'Entfernen',
        add: 'Weitere Fläche hinzufügen',
        save: 'Speichern',
        close: 'Schließen',
        types: {
            kitchen: 'Küche',
            living_room: 'Wohnzimmer',
            kitchen_w_living_room: 'Küche mit Wohnzimmer',
            bedroom: 'Schlafzimmer',
            children_room: 'Kinderzimmer',
            bathroom: 'Badezimmer',
            toilet: 'Toilette',
            hallway: 'Flur',
            gallery: 'Galerie',
            dressing_room: 'Garderobe',
            other: 'Andere',
            flat_technical_room: 'Technische Wohnung',
            technical_room: 'Technischer Raum',
            workshop: 'Werkstatt',
            uninhabited_attic: 'Unbewohnter Dachboden',
        }
    },

    reproduction: {
        flat_price: 'Reproduktionspreis der Wohnung',
        find_price: 'Ermitteln des Marktpreises',
        market_price: 'Berechnung des Marktpreises',
        reproduction_price: 'Berechnung des Reproduktionspreis',
    },

    prepositions: {
        of: 'von',
        in: 'in',
        from: 'von',
        to: 'zu',
    },

    result: '0 Ergebnisse | {n} Ergebnis | {n} Ergebnisse | {n} Ergebnisse',

    record_search: {
        btn: 'Auswahl nach Parametern',
        modal_title: 'Auswahl von Parametern und Immobilien',
        search_results_count: 'Mehr als {n} Ergebnisse gefunden. Verfeinern Sie die Auswahl.',
        btn_back: 'Zurück zur Parameternauswahl',
        table: {
            area: 'Fläche',
            price: 'Preis',
            pairing_status: 'Verkaufsabgleich',
        }
    },

    coefficients: {
        valued: 'Bewertete Immobilie',
        comparable: 'Vergleichbare Immobilie',
        better: 'Besser',
        same: 'Gleich',
        title_valued: 'Die bewertete Immobilie ist besser',
        title_comparable: 'Die vergleichbare Immobilie ist besser',
        difference: 'Unterschied',
        delete_custom_coef: 'Eintrag löschen',
        create_custom_coef: 'Weitere Eintrag hinzufügen',
        edit_advertised_price: 'Angepasster Angebotspreis',
        original_price: 'Ursprünglicher Preis',
        final_price: 'Endgültige Preisjustierung',
        edit_price: 'Angepasster Preis',
    },

}
